import React, {useEffect, useState} from 'react'
import ReadpointService from "../../services/ReadpointService";
import {PortalItem} from "./PortalItem";
import WebSocketTon, {Notificationtype} from "../../utils/WebSocket";
import UserService from "../../services/UserService";
import Loading from "../Loading/Loading";
import {Col, Row} from 'react-bootstrap';
import Box from '../Box/Box';

let PORTALS_EXTERNAL = null;

export const PortalList = ({history}) => {

  const [portals, setPortals] = useState(PORTALS_EXTERNAL);

  const onMessageInWebSocket = ({type, payload}) => {

    const data = payload.data && JSON.parse(payload.data)

    if (Notificationtype.NODE_PING_UPDATE_BY_READPOINT === type) {
      PORTALS_EXTERNAL = PORTALS_EXTERNAL.map(x => {
        if (x.nodeDetail && x.nodeDetail.id === payload.nodeDetailId) {
          const online = (payload.online === "true") 
          x.nodeDetail = {...x.nodeDetail, ...payload, online};
        }
        return {...x};
      });
      setPortals(PORTALS_EXTERNAL);
    }

    if (Notificationtype.NEW_TRANSACTION_TARGET === type) {
      PORTALS_EXTERNAL = PORTALS_EXTERNAL.map(x => {
        if (x.id === data.readPoint.id) {
          x.transactionTarget = data;
        }
        return {...x};
      });
      setPortals(PORTALS_EXTERNAL);
    }

    if (Notificationtype.CLOSE_TRANSACTION_TARGET === type) {
      PORTALS_EXTERNAL = PORTALS_EXTERNAL.map(x => {
        if (x.id === data.readPoint.id) {
          x.transactionTarget = null;
        }
        return {...x};
      });
      setPortals(PORTALS_EXTERNAL);
    }
  }

  const loadPortals = async () => {
    const result = await new ReadpointService().loadPortals()

    PORTALS_EXTERNAL = result.content;
    setPortals(PORTALS_EXTERNAL);
  }

  useEffect(() => {
    let subscriptionReadpoint = null;
    let subscriptionTransactionTarget = null;

    const subscribeInWS = async () => {
      subscriptionReadpoint = await WebSocketTon.getInstance().subscribe(`/topic/companies/${UserService.getCompanyId()}/readpoints/status`, onMessageInWebSocket);
      subscriptionTransactionTarget = await WebSocketTon.getInstance().subscribe(`/topic/companies/${UserService.getCompanyId()}/transactiontarget`, onMessageInWebSocket);
    }

    const executeInOrder = async () => {
      await loadPortals();
      subscribeInWS();
    }

    executeInOrder();
    
    return () => {
      subscriptionReadpoint && subscriptionReadpoint.unsubscribe();
      subscriptionTransactionTarget && subscriptionTransactionTarget.unsubscribe();
    }
  }, []);

  if (!portals) {
    return <Loading/>
  }

  const renderPortals = (portals) => {
    let groupedItems = []

    portals.forEach(portal => {

      if(groupedItems.length > 0) {
    
        groupedItems.forEach((item, i) => {
          if (portal.rpGroup === item.group) {
            groupedItems[i].items.push(portal)
          }
        
          const existingGroups = groupedItems.filter(item => item.group === portal.rpGroup)

          if (existingGroups.length <= 0) {
            groupedItems.push({ group: portal.rpGroup, items: [portal] })
          }
        })
      } else {
        groupedItems.push({ group: portal.rpGroup, items: [portal] })
      }
    })

    return groupedItems.map((x, i) => {
      return (
        <Box key={i} title={x.group || 'Sem grupo'}>
            <Row className="d-flex justify-content-center flex-wrap mb-5 ml-5 pb-5" >
              {
                x.items.map((y, i) => {
                  return <Col key={i}> <PortalItem history={history} key={y.id} portal={y}/> </Col>
                })
              }
            </Row>
        </Box>
      )
    })
  }

  const itens = portals.map((x, i) => <Col key={i}> <PortalItem history={history} key={x.id} portal={x}/> </Col>);

  if (itens.length === 0) {
    return <div style={{textAlign: 'center', marginTop: '10%'}}>
      <h1>Sem portais Disponíveis </h1>
    </div>
  }

  return (
    renderPortals(portals)
  )
}



// WEBPACK FOOTER //
// ./src/component/PortalList/PortalList.js